module.exports = __webpack_public_path__ + "img/obstacle_course.79b8d1d3.jpg";